export default __webpack_public_path__ + "static/media/direccion.fc13cbf2.svg";